export default "__VITE_ASSET__BjUQ6VP___"